import React from 'react';
export function Benefits() {
  return <section className="py-12 bg-green-50 rounded-lg" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 mb-8" data-id="element-14">
          I Looked It Up Immediately. And What I Found Shocked Me.
        </h2>
        <p className="text-xl mb-6" data-id="element-15">
          Aya Caps wasn't some trendy brand with flashy labels. It was run by a
          team that had actually spent time in the Amazon.
        </p>
        <p className="text-xl mb-6" data-id="element-16">
          They work directly with local communities. They protect the forest.
          They only use wildcrafted, ceremonial-grade vine.
        </p>
        <p className="text-xl mb-6" data-id="element-17">
          And they made it into capsules that anyone could take at home —
          legally.
        </p>
        <p className="text-xl font-bold mb-6" data-id="element-18">No trip. Just the medicine.</p>
        <p className="text-xl mb-6" data-id="element-19">They even had a 30-day guarantee.</p>
        <p className="text-xl font-bold mb-6" data-id="element-20">
          Try it. And if you don't feel a shift? Get your money back.
        </p>
        <p className="text-xl font-bold mb-6" data-id="element-21">
          And the offer that day? Buy 2, get 1 free.
        </p>
        <p className="text-xl mb-6" data-id="element-22">
          I didn't even think twice. I clicked the link. And ordered.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 my-8" data-id="element-23">
          What Happened Next Wasn't Dramatic. But It Was Real.
        </h2>
        <div className="my-8" data-id="element-24">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vZuzST2i7BAt7pmBT6zECd/Tman_977049b7-b814-4cc9-8cf3-8075d172bf05.webp" alt="Person experiencing clarity and peace at sunrise" className="mx-auto rounded-lg shadow-lg max-w-full" data-id="element-25" />
          <p className="text-sm text-center text-gray-600 mt-2" data-id="element-26">
            Finding peace and clarity after anxiety
          </p>
        </div>
        <p className="text-xl mb-6" data-id="element-27">
          The first time I took it, I didn't feel much. No buzz. No high. No
          crash.
        </p>
        <p className="text-xl mb-6" data-id="element-28">
          But by the third or fourth dose, I started noticing things.
        </p>
        <p className="text-xl mb-6" data-id="element-29">
          I could actually take a deep breath. My shoulders weren't up to my
          ears all day. I didn't flip out when I got that stressful email.
        </p>
        <p className="text-xl mb-6" data-id="element-30">
          It was like my nervous system had more room. More flexibility. More
          capacity.
        </p>
        <p className="text-xl mb-6" data-id="element-31">
          And now? I feel more present with my wife. More patient with my kid.
          More steady in my own skin.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 my-8" data-id="element-32">
          I still want to sit in on the ceremony one day. But for now, this is
          my ceremony.
        </h2>
        <p className="text-xl mb-6" data-id="element-33">
          One capsule at a time. Three days a week. Letting the vine do its
          quiet work.
        </p>
        <p className="text-xl mb-6" data-id="element-34">
          And if you've been waiting for a sign? Maybe this is yours.
        </p>
        <p className="text-xl mb-6" data-id="element-35">
          Just see what thousands of Americans have to say about the healing
          effects of the vine:
        </p>
      </div>
    </section>;
}